import React from 'react'
import { Mail, MapPin, Phone, Facebook, Instagram } from "lucide-react"
import { FaTiktok } from "react-icons/fa6"
import { Link } from 'react-router-dom'

const TopBar = () => {
  return (
    <div className="flex hidden md:grid lg:grid-cols-10 grid-cols-8">
      <div className="col-span-7 lg:col-span-9 grid grid-cols-2 lg:grid-cols-3 gap-5 bg-gradient-to-r from-[#221B2D] to-[#020D24] text-white py-5 px-5 lg:text-md xl:text-lg text-[12px]">
        <div className="flex items-center gap-1.5 leading-none">
            <Mail className="w-4 h-4" /> 
            <span>info@anell.edu.gh &nbsp; | &nbsp; admission@anell.edu.gh</span>
          </div>
          <div className="flex items-center gap-1.5 leading-none">
            <MapPin className="w-4 h-4" /> 
            <span>Kumasi, Airport Road, Kenyasi</span>
          </div>
        <div className="flex items-center gap-1.5 leading-none">
          <Phone className="w-4 h-4" /> 
          <span>0322 499 539 / +233504828824</span>
        </div>
      </div>
      <div className="bg-white py-5 pr-5 md:pr-10 pl-2.5 flex justify-center items-center gap-2">
        <Link 
          to="https://web.facebook.com/anellschoolofexcellence?mibextid=ZbWKwL&_rdc=1&_rdr" 
          className="bg-black p-2 rounded-full text-white transition-all duration-200 hover:bg-[#fb8500] hover:cursor-pointer"
        >
          <Facebook className="w-5 h-5 laptop:w-3.5 laptop:h-3.5" />
        </Link>
        <Link 
          to="https://instagram.com/anellschoolofexcellence?igshid=NTc4MTIwNjQ2YQ" 
          className="bg-black p-2 rounded-full text-white transition-all duration-200 hover:bg-[#fb8500] hover:cursor-pointer"
        >
          <Instagram className="w-5 h-5 laptop:w-3.5 laptop:h-3.5" />
        </Link>
        <Link 
          to="https://www.tiktok.com/@anellschoolofexcellence" 
          target="_blank"
          className="bg-black p-2 rounded-full text-white transition-all duration-200 hover:bg-[#fb8500] hover:cursor-pointer"
        >
          <FaTiktok className="w-5 h-5 laptop:w-3.5 laptop:h-3.5" />
        </Link>
      </div>
    </div>
  )
}

export default TopBar